import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeedbackService } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';
import { UsersService, IUserRoleSources } from '../../../../../../services/users';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { IRolesSourcesDialogData } from './users-roles-sources.models';

@Component({
	selector: 'app-users-roles-sources-dialog',
	templateUrl: './users-roles-sources.dialog.html',
	styleUrls: ['./users-roles-sources.dialog.scss']
})
export class UsersRolesSourcesDialogComponent extends OnDestroyMixin implements OnInit {
	@Input() public embedded = false;
	@Input() public dialogData: IRolesSourcesDialogData;

	roleSources: IUserRoleSources = { cognito: [], dynamoDBUserRole: [], dynamoDBUserIdentityMap: [], sis: [] };

	private readonly alphabeticSort = (a: string, b: string): number => a.localeCompare(b, undefined, { sensitivity: 'base' });

	constructor(
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Optional() @Inject(MAT_DIALOG_DATA) private injectedDialogData: IRolesSourcesDialogData
	) {
		super();
	}

	ngOnInit(): void {
		this.dialogData = this.dialogData || this.injectedDialogData;
		this.getRolesSources();
	}

	public getRolesSources(): void {
		if (!this.dialogData?.user) {
			this.progressIndicatorService.spinner(false);
			return;
		}

		this.progressIndicatorService.spinner(true);

		this.usersService.getUserRolesSources(this.dialogData.user.id, this.dialogData.user.email).subscribe({
			next: (sources: IUserRoleSources) => {
				this.roleSources = this.getSortedRoleSources(sources);
				this.progressIndicatorService.spinner(false);
			},
			error: (error: any) => {
				this.feedbackService.apiError(error);
				this.progressIndicatorService.spinner(false);
			}
		});
	}

	private getSortedRoleSources(sources: IUserRoleSources): IUserRoleSources {
		return {
			cognito: [...(sources?.cognito || [])].sort(this.alphabeticSort),
			dynamoDBUserRole: [...(sources?.dynamoDBUserRole || [])].sort(this.alphabeticSort),
			dynamoDBUserIdentityMap: [...(sources?.dynamoDBUserIdentityMap || [])].sort(this.alphabeticSort),
			sis: [...(sources?.sis || [])].sort(this.alphabeticSort)
		};
	}
}

